import classNames from "classnames";
import React from "react";
import styles from "./Bubble.scss";

export const Bubble = ({ direction = "left", color, children, className }) => {
    return (
        <div
            className={classNames(
                styles.base,
                {
                    [styles.directionLeft]: direction === "left",
                    [styles.directionRight]: direction === "right",
                    [styles.colorWarning]: color === "warning"
                },
                className
            )}
        >
            {children}
        </div>
    );
};
